import React from 'react'

export const PageNotFound = () => {
  return (
    <div>Page Not Found!</div>
  )
}
